<template>
  <div id="app">
    <Loading></Loading>
    <Menu></Menu>
    <router-view/>
    <Footer></Footer>
    <HomeFixBar v-on:closed="closeTab = !closeTab"></HomeFixBar>
    <div class="footer_spacing w-100 d-none d-lg-block" v-if="!closeTab"></div>
  </div>
</template>

<script>
import Loading from './components/Loading.vue'
import Menu from './components/Menu.vue'
import Footer from './components/Footer.vue'
import HomeFixBar from './components/HomeFixBar.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'App',

  components: {
    Loading,
    Menu,
    Footer,
    HomeFixBar
  },
  computed: {
    ...mapGetters([
      'page'
    ])
  },

  created () {
    document.title = `${this.$route.name}`
    if (this.$route.params.slug) {
      document.title = `${this.$route.params.slug}`
    }
  },

  data () {
    return {
      closeTab: false
    }
  },

  watch: {
    '$route' (to, from) {
      switch (to.name) {
        case 'Home':
          this.scroll()
          document.title = 'Comcasa | Home'
          break
        case 'Sobre':
          this.scroll()
          document.title = 'Comcasa | Sobre'
          break
        case 'Historia':
          this.scroll()
          document.title = 'Comcasa | História'
          break
        case 'Valores':
          this.scroll()
          document.title = 'Comcasa | Valores'
          break
        case 'Diferenciais':
          this.scroll()
          document.title = 'Comcasa | Diferenciais'
          break
        case 'Empresas':
          this.scroll()
          document.title = 'Comcasa | Empresas'
          break
        case 'Empreendimentos':
          this.scroll()
          document.title = 'Comcasa | Empreendimentos'
          break
        case 'Comparar':
          this.scroll()
          document.title = 'Comcasa | Comparar'
          break
        case 'InternaApresentacao':
          this.scroll()
          break
        case 'Blog':
          this.scroll()
          document.title = 'Comcasa | Blog'
          break
        case 'BlogInterna':
          this.scroll()
          break
        case 'Contato':
          document.title = 'Comcasa | Contato'
          this.scroll()
          break
        case 'Campanha':
          document.title = 'Comcasa | Campanha'
          this.scroll()
          break
        default :
          this.scroll()
          document.title = 'Comcasa | Home'
          break
      }
    }
  },
  methods: {
    scroll () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss">
@import "assets/scss/app.scss";
@import "../node_modules/bootstrap/scss/bootstrap.scss";
.footer_spacing {
  background: #0f1425;
  height: 90px;
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue